import { render, staticRenderFns } from "./ActivityAdvice.vue?vue&type=template&id=21dfc002&scoped=true&"
import script from "./ActivityAdvice.vue?vue&type=script&lang=js&"
export * from "./ActivityAdvice.vue?vue&type=script&lang=js&"
import style0 from "./ActivityAdvice.vue?vue&type=style&index=0&id=21dfc002&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21dfc002",
  null
  
)

export default component.exports